import React from 'react'
import { connect } from 'react-redux'
import {
  showPopupDialog,
  showPopupErrorSnackbar,
  showPopupSuccessSnackbar,
} from 'support/popup_dialogs'
import i18n from 'support/i18n'
import Navigation from 'support/navigation'
import ErrorSubmitModal from './dialogs/ErrorSubmitContainer'
import SucessSubmitModal from './dialogs/SucessSubmitContainer'
import View from './View'
import { postScorecardTemplateCreate } from 'services/innovate/templates'

const mapStateToProps = state => ({
  myEmail: state.data.user.userEmail,
  createScorecardTemplateLoading: state.data.templates.createScorecardTemplateLoading,
  updateScorecardTemplateLoading: state.data.templates.updateScorecardTemplateLoading,
  createScorecardTemplate:state.data.templates.createScorecardTemplate,
  updateScorecardTemplate:state.data.templates.updateScorecardTemplate
})

const mapDispatchToProps = dispatch => {
  return {
    postScorecardTemplateCreateFn:(email,adminCreateTemplateData)=>{
      console.log("create Value", adminCreateTemplateData)
      const onSuccess = data => {
        const message='Your Template is Successfully Created'
        // showPopupSuccessSnackbar(message, dispatch)
        showPopupDialog(<SucessSubmitModal description={message} />, dispatch)
      }
      const onFailure = ({ data }) => {
        const errorMessage = data?.error?.msg?.en || 'An unexpected error occurred';
        const messageTag =
          data && data.error && data.error.error
            ? `BACKEND_ERRORS.${data.error.error}`
            : 'BACKEND_ERRORS.UNEXPECTED'
            showPopupDialog(<ErrorSubmitModal description={errorMessage} />, dispatch)
      }
      dispatch(postScorecardTemplateCreate(email,adminCreateTemplateData,onSuccess,onFailure))
      
    },

  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
